import { faker } from '@faker-js/faker';
import {
  DXAReading,
  DXAWorkstationDataDTO,
} from '@dynamika-shared/types/DXAReading';

export function createRandomDXAWorkstationData(dates: string[]): DXAReading {
  return {
    fileName: faker.system.fileName(),
    label: faker.number.int(),
    scanType: faker.number.int(),
    labelId: faker.string.uuid(),
    recordId: faker.string.uuid(),
    acquisitionDate: faker.helpers.arrayElement([...dates, null]),
    bodyRegion: faker.helpers.arrayElement([
      'Lumbar Spine',
      'Femoral Neck',
      'Left Arm',
      'Forearm',
      'Hip',
      null,
    ]),
    compositionScore: {
      boneMass: faker.number.float(),
      fatMass: faker.number.float(),
      leanMass: faker.number.float(),
    },
    densitometryScore: {
      bmd: faker.number.float(),
      bmc: faker.number.float(),
      area: faker.number.float(),
    },
    bodyProperty: faker.helpers.arrayElement([
      'L1-L2',
      'L1-L3',
      'L1-L4',
      'L2-L3',
      'L2-L4',
      'L3-L4',
      'Hip',
      null,
    ]),
    tScore: faker.helpers.arrayElement([faker.number.float(), null]),
    zScore: faker.helpers.arrayElement([faker.number.float(), null]),
    id: faker.string.uuid(),
  };
}

export const createRandomDXAWorkstationDataDTO = (
  dates: string[],
  count: number = 10
): DXAWorkstationDataDTO => {
  return {
    id: faker.string.uuid(),
    clinicalTrialId: faker.string.uuid(),
    patientId: faker.string.uuid(),
    dxaScores: faker.helpers.multiple(() => createRandomDXAWorkstationData(dates), { count }),
  };
};

export function createRandomDXAWorkstationDataList(
  count: number
): DXAWorkstationDataDTO[] {
  const dates = [
    faker.date.recent().toISOString(),
    faker.date.recent().toISOString(),
    faker.date.recent().toISOString(),
    faker.date.recent().toISOString(),
  ];
  return faker.helpers.multiple(() => createRandomDXAWorkstationDataDTO(dates, count), { count });
}
